<mat-slide-toggle
[checked]="checked"
(change)="onToggleChange($event)">
</mat-slide-toggle>